<template>
  <div class="page">
    <div class="content">
      <div class="content_child">
        <p class="money">账户余额￥{{faMsg}}元</p>
        <div>
          <el-form :model="form" :label-position="labelPosition" label-width="80px" :rules="rules" ref="ruleForm" v-show="active == true">
            <el-form-item label="提现金额" prop="money">
              <el-input class="inputsty" v-model="form.money" placeholder="  请输入充值金额"></el-input>
              <span style="padding-left:10px;color:#c0c4cc;">元</span>
            </el-form-item>
            <el-form-item label="您的姓名" prop="name">
              <el-input class="inputsty" v-model="form.name" placeholder="  您的姓名"></el-input>
            </el-form-item>
            <div class="typesty">
              <span style="padding-right:10px;">提现方式</span>

              <div class="contentbottonchild" @click="active = true,flags=false" v-show="active==false">
                <img src="/img/yinhang-a.png" />
                <span>银行卡</span>
              </div>
              <div class="contentbottonchilda" v-show="active == true">
                <img src="/img/yinhang-b.png" />
                <span>银行卡</span>
              </div>
              <div class="contentbottonchild" style="margin-left:35px;" @click="active=false,flags=true" v-show="flags == false">
                <img src="/img/payd.png" />
                <span>支付宝</span>
              </div>
              <div class="contentbottonchildb" style="margin-left:35px;" v-show="flags == true">
                <img src="/img/payc.png" />
                <span>支付宝</span>
              </div>
            </div>
            <div class="aside_box">
              <div style="padding-right:10px;">银行选择</div>
              <div class="asideboxs">
                <el-select v-model="value" placeholder="请选择" @change="selectproject">
                  <el-option v-for="(item,index) in options" :key="index" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </div>
            </div>
            <el-form-item label="银行卡号" prop="bankcardnumber">
              <el-input class="inputsty" disabled v-model="form.bankcardnumber" placeholder="  请输入银行卡号"></el-input>
            </el-form-item>
            <el-form-item label="验证手机" prop="phone">
              <el-input class="inputsty" disabled v-model="form.phone" placeholder="  请输入银行绑定手机号"></el-input>
            </el-form-item>
            <el-form-item type="number" label="验证码" prop="code">
              <el-input class="inputstys" v-model="form.code" placeholder="  请输入验证码"></el-input>
              <span class="btn" v-if="codeShow" @click="getcode">获取验证码</span>
              <span v-if="!codeShow" style="color:#4C71DB;font-size:12px;">{{count}}秒后重试</span>
            </el-form-item>
            <el-form-item label="输入密码" prop="password">
              <el-input type="password" class="inputsty" v-model="form.password" placeholder="  请输入密码"></el-input>
            </el-form-item>
          </el-form>

          <el-form :model="forms" :label-position="labelPosition" label-width="80px" :rules="rule" ref="ruleForms" v-show="active == false">
            <el-form-item label="提现金额" prop="money">
              <el-input class="inputsty" v-model="forms.money" placeholder="  请输入充值金额"></el-input>
              <span style="padding-left:10px;color:#c0c4cc;">元</span>
            </el-form-item>
            <el-form-item label="您的姓名" prop="name">
              <el-input class="inputsty" v-model="forms.name" placeholder="  您的姓名"></el-input>
            </el-form-item>
            <div class="typesty">
              <span style="padding-right:10px;">提现方式</span>

              <div class="contentbottonchild" @click="active = true,flags=false" v-show="active==false">
                <img src="/img/yinhang-a.png" />
                <span>银行卡</span>
              </div>
              <div class="contentbottonchilda" v-show="active == true">
                <img src="/img/yinhang-b.png" />
                <span>银行卡</span>
              </div>
              <div class="contentbottonchild" style="margin-left:35px;" @click="active=false,flags=true" v-show="flags == false">
                <img src="/img/payd.png" />
                <span>支付宝</span>
              </div>
              <div class="contentbottonchildb" style="margin-left:35px;" v-show="flags == true">
                <img src="/img/payc.png" />
                <span>支付宝</span>
              </div>
            </div>
            <el-form-item label="支付宝账号" prop="payment">
              <el-input class="inputsty" v-model="forms.payment" placeholder="  请输入支付宝账号"></el-input>
            </el-form-item>
            <el-form-item label="输入密码" prop="password">
              <el-input type="password" class="inputsty" v-model="forms.password" placeholder="  请输入密码"></el-input>
            </el-form-item>
          </el-form>
          <div class="updatebtn" v-show="active == true" @click="submitForm('ruleForm')">确认提现</div>
          <div class="updatebtn" v-show="active == false" @click="submitForms('ruleForms')">确认提现</div>
          <div style="height:50px;"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { cashtoadd, cashbanklist, mobilesms } from "@/api/login/login";
export default {
  props: ["faMsg"],
  data () {
    return {
      count: 0,
      codeShow: true,
      blank_id: "",
      value: "",
      active: true,
      flags: false,
      labelPosition: "right",
      banklist: [],
      form: {
        money: "",
        name: "",
        bank: "",
        bankcardnumber: "",
        phone: "",
        code: "",
        password: "",
        payment: ""
      },
      forms: {
        money: "",
        name: "",
        password: "",
        payment: ""
      },
      rule: {
        money: [
          { required: true, message: "请输入提现金额", trigger: "blur" },
          {
            pattern: /^\d+(\.\d{0,2})?$/,
            message: "只能是数字",
            trigger: "blur"
          }
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" }
        ],
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        payment: [
          { required: true, message: "请输入支付宝", trigger: "blur" },
          {
            pattern: /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/,
            message: "格式不对，请重新输入",
            trigger: "blur"
          }
        ]
      },
      rules: {
        bankcardnumber: [
          { required: true, message: "请输入银行卡号", trigger: "blur" },
          {
            // pattern: /^([1-9]{1})(\d{15}|\d{16}|\d{18})$/,
            min: 13,
            max: 19,
            message: "银行卡号格式不对",
            trigger: "blur"
          }
        ],
        money: [
          { required: true, message: "请输入提现金额", trigger: "blur" },
          {
            pattern: /^\d+(\.\d{0,2})?$/,
            message: "只能是数字",
            trigger: "blur"
          }
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" }
        ],
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        code: [
          { required: true, message: "请输入验证码", trigger: "blur" },
          {
            pattern: /^[0-9]*$/,
            message: "只能是数字",
            trigger: "blur"
          },
          { min: 5, max: 5, message: "五位验证码", trigger: "blur" }
        ],
        phone: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          {
            pattern: /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/,
            message: "手机号码格式不对，请重新输入",
            trigger: "blur"
          }
        ]
      },
      options: []
    };
  },
  mounted () {
    this.getbanklist();
  },
  methods: {
    //获取验证码
    getcode () {
      if (this.form.phone != "") {
        let data = {
          mobile: this.form.phone,
          mobile_type: 8
        };
        mobilesms(data).then(res => {
          if (res.code == 200) {
            const TIME_COUNT = 60;
            if (!this.timer) {
              this.count = TIME_COUNT;
              this.codeShow = false;
              this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) {
                  this.count--;
                } else {
                  this.codeShow = true;
                  clearInterval(this.timer);
                  this.timer = null;
                }
              }, 1000);
            }
            this.$message({
              type: "success",
              message: res.msg
            });
          }
        });
      } else {
        this.$message({
          type: "warning",
          message: "请先输入手机号"
        });
      }
    },
    submitForms (formName) {
      if (this.forms.money <= 0) {
        this.$message({
          type: 'warning',
          message: '金额不能小于0'
        })
        return
      }
      this.$refs[formName].validate(valid => {
        if (valid) {
          let number = 1;
          if (this.active == true) {
            number = 1;
          } else {
            number = 2;
          }
          let data = {
            type: number,
            user_name: this.forms.name,
            money: this.forms.money,
            password: this.forms.password,
            alipay_no: this.forms.payment,
          };
          console.log(data);
          cashtoadd(data).then(res => {
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: res.msg
              });
              this.forms = {};
            } else {
              this.$message({
                type: "warning",
                message: res.msg
              });
            }
          });
        } else {
          console.log("验证失败");
        }
      });
    },
    submitForm (formName) {
      if (this.blank_id == "") {
        this.$message({
          type: "warning",
          message: "请先选择银行"
        });
        return;
      }
      if (this.form.money <= 0) {
        this.$message({
          type: 'warning',
          message: '金额不能小于0'
        })
        return
      }
      this.$refs[formName].validate(valid => {
        if (valid) {
          let number = 1;
          if (this.active == true) {
            number = 1;
          } else {
            number = 2;
          }
          let data = {
            type: number,
            user_name: this.form.name,
            money: this.form.money,
            password: this.form.password,
            bank_id: this.blank_id,
            bank_no: this.form.bankcardnumber,
            phone: this.form.phone,
            phone_mode: this.form.code
          };
          cashtoadd(data).then(res => {
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: res.msg
              });
              this.value = '请选择'
              this.form = {};
            } else {
              this.$message({
                type: "warning",
                message: res.msg
              });
            }
          });
        } else {
          console.log("验证失败");
        }
      });
    },
    //银行选择
    selectproject (e) {
      this.blank_id = e;
      this.banklist.forEach(item => {
        if (item.id == e) {
          this.form.bankcardnumber = item.bank_no
          this.form.phone = item.bank_mobile
        }
      })
    },
    //获取银行卡列表
    getbanklist () {
      cashbanklist().then(res => {
        let data = {};
        if (res.code == 200) {
          this.banklist = res.data
          res.data.forEach(item => {
            data = {
              value: item.id,
              label: item.bank_name
            };
            this.options.push(data);
          });
        }
      });
    }
  },
  components: {}
};
</script>

<style lang='scss' scoped>
.page {
  .content {
    height: 500px;
    overflow-y: scroll;
    overflow-x: hidden;
    .content_child {
      .aside_box {
        margin: 10px 0;
        margin-left: 20px;
        display: flex;
        align-items: center;
        font-size: 12px;
      }
      .typesty {
        font-size: 12px;
        margin-top: 20px;
        margin-bottom: 20px;
        padding-left: 21px;
        display: flex;
        .contentbottonchildb {
          width: 150px;
          height: 30px;
          display: flex;
          color: white;
          justify-content: center;
          align-items: center;
          border-radius: 8px;
          background-color: #1496dc;
          img {
            width: 30px;
            height: 30px;
          }
        }
        .contentbottonchilda {
          width: 150px;
          height: 30px;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 8px;
          color: white;
          background-color: #03cc02;
          img {
            width: 30px;
            height: 30px;
          }
        }
        .contentbottonchild {
          width: 10%;
          height: 30px;
          border: 1px solid #ccc;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 8px;
          img {
            width: 30px;
            height: 30px;
          }
        }
      }

      .money {
        margin-bottom: 30px;
        margin-left: 20px;
      }
      .inputsty {
        width: 300px;
      }
      .inputstys {
        width: 200px;
        margin-right: 10px;
      }
      border-radius: 8px;
      background-color: white;
      padding-top: 30px;
      padding-left: 25px;
      .updatebtn {
        width: 120px;
        height: 40px;
        background-color: #4c71db;
        border-radius: 7px;
        color: white;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        margin-left: 100px;
        margin-top: 50px;
      }
      .btn {
        padding: 10px 20px;
        background-color: #4c71db;
        border-radius: 7px;
        color: white;
        font-size: 14px;
      }
    }
  }
  height: auto !important;
}
</style>
